module.exports = __webpack_public_path__ + "static/media/WeddSite.736b26c1.png";